import React, { useEffect, useState } from "react";
import "../../../../src/App.css";
import LoadingPage from "../../Components/layouts/loading";
import performRequest from "../../api/request";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import StepRoutes from "../../Routes/steps_routes";
import DynamicFilterInput from "../../Components/layouts/filter.inpit";
import DynamicFilterSelect from "../../Components/layouts/filter.select";
import Pagination from "../../Components/layouts/pagination";
import Footer from "../../Components/Footer/footer";
import { FcCurrencyExchange, FcKindle } from "react-icons/fc";
import {
  extractDate,
  returnMonthDateYear,
} from "../../Components/Functions/date.fun";
import { BsArrowRightShort } from "react-icons/bs";
import getFilteredURL from "../../Components/Functions/filters.getUrl";
import { manualPaymentInitialValues } from "../../SchemaInfo/info";
import { manualPaymentSchema } from "../../Schemas/webinar/mannual_entry";
import { Formik, Form } from "formik";
import CustomInput from "../../CustomComponent/custom_input";
import WebinarStats from "./webinar_stats";
import { Toast } from "../../CustomComponent/toast";
import WebinarPayChart from "./webinars/webinarPayChart";
import CustomSelect from "../../CustomComponent/custom_select";

function AllWebinarPayments() {
  const [loading, setLoading] = useState(false);
  const [webinarDetails, setWebinarDetails] = useState({});
  const [webinarPaymentDetails, setWebinarPaymentDetails] = useState({});
  const [webinarFrom, setWebinarFrom] = useState(30);
  const [webinarPurchases, setWebinarPurchases] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [filters, setFilters] = useState({
    startdate: "",
    enddate: "",
    name: "",
    paymentStatus: "",
    webinarId: "",
  });

  const [page, setPage] = useState(1);
  const [showPage, setShowPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [data, setData] = useState([]);
  const [webinars, setWebinars] = useState([]);
  useEffect(() => {
    performRequest("GET", `/webinar/get-all-webinar-purchases`)
      .then((res) => {
        if (res.status === 200) {
          setWebinarPurchases(res?.data);
        } else {
          Toast("error", "Error while getting employee feedbacks!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, [refresh]);
  useEffect(() => {
    setLoading(true);
    performRequest(
      "GET",
      getFilteredURL("/payment/get-all-webinar-payments/", page, filters)
    )
      .then((res) => {
        if (res.status === 200) {
          setData(res.data.webinarBookingData);
          setTotalPages(Math.ceil(res.data.webinarBookingCount / 50));
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [refresh, page]);

  useEffect(() => {
    performRequest("GET", "/webinar/get-all-webinar?withoutFilters=true").then(
      (res) => {
        if (res.status === 200) {
          setWebinars(res?.data?.webinar);
        }
      }
    );
  }, []);

  const handleWebinarDetails = (el) => {
    setWebinarPaymentDetails(el);
    performRequest("GET", `/webinar/getwebinarById/${el.webinarId}`)
      .then((res) => {
        if (res.status === 200) {
          setWebinarDetails(res.data);
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  };
  const handleManualPaymentSubmit = (values) => {
    setLoading(true);
    performRequest("POST", `/payment/create-manual-payment`, values)
      .then((res) => {
        if (res.status === 200) {
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
    window.location.reload();
  };

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <>
      <div className="page">
        <div className="page-wrapper">
          <div style={{ minHeight: "80vh" }}>
            <div className="page-header d-print-none">
              <div className="container-xl">
                <div className="row g-2 align-items-center">
                  <div className="col">
                    <h2 className="page-title">
                      <FcCurrencyExchange className="fs-2  me-1" />
                      Webinar Payments
                    </h2>
                    <h4 className="text-muted">
                      <StepRoutes />
                    </h4>
                  </div>

                  <div className="col-auto ms-auto d-print-none">
                    <div className="d-flex d-none d-sm-block gap-3"></div>
                  </div>
                </div>
              </div>
            </div>
            <div className="page-body">
              <div className="container-xl">
                <div className="row  row-deck row-cards">
                  <div className="col-md-3 col-sm-12">
                    <WebinarStats data="data" />
                  </div>
                  <div className="col-md-9 col-sm-12">
                    <div className="card">
                      <div className="card-header">
                        <h3 className="card-title">Webinar Purchase Summary</h3>
                        <div className="ms-auto">
                          <div className="d-flex">
                            <div className="dropdown">
                              <a
                                className="dropdown-toggle text-muted"
                                href="/"
                                data-bs-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                              >
                                Last {webinarFrom || 30} days
                              </a>
                              <div className="dropdown-menu dropdown-menu-end">
                                <span
                                  onClick={() => setWebinarFrom(7)}
                                  className="dropdown-item"
                                >
                                  Last 7 days
                                </span>
                                <span
                                  onClick={() => setWebinarFrom(30)}
                                  className="dropdown-item"
                                >
                                  Last 30 days
                                </span>
                                <span
                                  onClick={() => setWebinarFrom(45)}
                                  className="dropdown-item"
                                >
                                  Last 45 days
                                </span>
                                <span
                                  onClick={() => setWebinarFrom(60)}
                                  className="dropdown-item"
                                >
                                  Last 2 months
                                </span>
                                <span
                                  onClick={() => setWebinarFrom(90)}
                                  className="dropdown-item"
                                >
                                  Last 3 months
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        style={{
                          maxHeight: "400px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        {webinarPurchases && webinarPurchases.length > 0 && (
                          <WebinarPayChart
                            webinarPurchases={webinarPurchases}
                            webinarFrom={webinarFrom}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-3 col-sm-12">
                    <div className="card p-2">
                      <div
                        id="faq-1"
                        className="accordion"
                        role="tablist"
                        aria-multiselectable="true"
                      >
                        <div>
                          <div className="accordion-header m-0" role="tab">
                            <button
                              className="accordion-button fs-3 d-md-none p-0"
                              data-bs-toggle="collapse"
                              data-bs-target="#faq-1-1"
                            >
                              <h3 className="m-1">Filter result</h3>
                            </button>
                          </div>

                          <div
                            id="faq-1-1"
                            className="accordion-collapse collapse d-md-none"
                            role="tabpanel"
                            data-bs-parent="#faq-1"
                          >
                            <div className="accordion-body pt-0">
                              <div className="row">
                                <div className="col-12">
                                  <DynamicFilterInput
                                    label="Start Date:"
                                    value={filters.startdate}
                                    onChange={(e) =>
                                      setFilters({
                                        ...filters,
                                        startdate: e.target.value,
                                      })
                                    }
                                    type="date"
                                  />
                                </div>
                                <div className="col-12">
                                  <DynamicFilterInput
                                    label="End Date:"
                                    value={filters.enddate}
                                    onChange={(e) =>
                                      setFilters({
                                        ...filters,
                                        enddate: e.target.value,
                                      })
                                    }
                                    type="date"
                                  />
                                </div>
                                <div className="col-12">
                                  <DynamicFilterSelect
                                    label="Get by webinar:"
                                    onChange={(e) =>
                                      setFilters({
                                        ...filters,
                                        webinarId: e.target.value,
                                      })
                                    }
                                    value={filters.webinarId}
                                  >
                                    <option value="">Select</option>
                                    {webinars?.map((el, index) => (
                                      <option value={el.id}>
                                        {el.webinarName}
                                      </option>
                                    ))}
                                    <option value="Sent">Sent</option>
                                    <option value="Pending">Pending</option>
                                  </DynamicFilterSelect>
                                </div>
                                <div className="col-12">
                                  <DynamicFilterInput
                                    label="Search name/phone/email"
                                    value={filters.name}
                                    onChange={(e) =>
                                      setFilters({
                                        ...filters,
                                        name: e.target.value,
                                      })
                                    }
                                    placeholder="search name..."
                                  />
                                </div>

                                <div className="col-12">
                                  <DynamicFilterSelect
                                    label="Payment Status:"
                                    onChange={(e) =>
                                      setFilters({
                                        ...filters,
                                        paymentStatus: e.target.value,
                                      })
                                    }
                                    value={filters.paymentStatus}
                                  >
                                    <option value="">Select</option>
                                    <option value="Completed">Completed</option>
                                    <option value="Sent">Sent</option>
                                    <option value="Pending">Pending</option>
                                  </DynamicFilterSelect>
                                </div>

                                <div className="col-12">
                                  <div className="row mt-2">
                                    <div className="col-6">
                                      <button
                                        onClick={() => setRefresh(!refresh)}
                                        className="btn btn-success w-100"
                                      >
                                        Apply Filter
                                      </button>
                                    </div>
                                    <div className="col-6">
                                      <button
                                        onClick={() => {
                                          setFilters({
                                            startdate: "",
                                            enddate: "",
                                            name: "",
                                            paymentStatus: "",
                                            webinarId: "",
                                          });
                                          setRefresh(!refresh);
                                        }}
                                        className="btn btn-secondary w-100"
                                      >
                                        Reset Filter
                                      </button>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-12 mt-2 " data-label="me">
                                  <button
                                    className="btn btn-primary"
                                    data-bs-toggle="modal"
                                    data-bs-target="#manual-payment"
                                  >
                                    Manual Payment Entry
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="accordion-body d-none d-md-block">
                            <div className="row">
                              <h3>Filter result</h3>
                              <div className="col-12">
                                <DynamicFilterInput
                                  label="Start Date:"
                                  value={filters.startdate}
                                  onChange={(e) =>
                                    setFilters({
                                      ...filters,
                                      startdate: e.target.value,
                                    })
                                  }
                                  type="date"
                                />
                              </div>
                              <div className="col-12">
                                <DynamicFilterInput
                                  label="End Date:"
                                  value={filters.enddate}
                                  onChange={(e) =>
                                    setFilters({
                                      ...filters,
                                      enddate: e.target.value,
                                    })
                                  }
                                  type="date"
                                />
                              </div>
                              <div className="col-12">
                                <DynamicFilterSelect
                                  label="Get by webinar:"
                                  onChange={(e) =>
                                    setFilters({
                                      ...filters,
                                      webinarId: e.target.value,
                                    })
                                  }
                                  value={filters.webinarId}
                                >
                                  <option value="">Select</option>
                                  {webinars?.map((el, index) => (
                                    <option value={el.id}>
                                      {el.webinarName}
                                    </option>
                                  ))}
                                  <option value="Sent">Sent</option>
                                  <option value="Pending">Pending</option>
                                </DynamicFilterSelect>
                              </div>
                              <div className="col-12">
                                <DynamicFilterInput
                                  label="Search name/mobile/email"
                                  value={filters.name}
                                  onChange={(e) =>
                                    setFilters({
                                      ...filters,
                                      name: e.target.value,
                                    })
                                  }
                                  placeholder="search name..."
                                />
                              </div>

                              <div className="col-12">
                                <DynamicFilterSelect
                                  label="Payment Status:"
                                  onChange={(e) =>
                                    setFilters({
                                      ...filters,
                                      paymentStatus: e.target.value,
                                    })
                                  }
                                  value={filters.paymentStatus}
                                >
                                  <option value="">Select</option>
                                  <option value="Completed">Completed</option>
                                  <option value="Sent">Sent</option>
                                  <option value="Pending">Pending</option>
                                </DynamicFilterSelect>
                              </div>

                              <div className="col-12">
                                <div className="row mt-2">
                                  <div className="col-6">
                                    <button
                                      onClick={() => setRefresh(!refresh)}
                                      className="btn btn-success w-100"
                                    >
                                      Apply Filter
                                    </button>
                                  </div>
                                  <div className="col-6">
                                    <button
                                      onClick={() => {
                                        setFilters({
                                          startdate: "",
                                          enddate: "",
                                          name: "",
                                          paymentStatus: "",
                                          webinarId: "",
                                        });
                                        setRefresh(!refresh);
                                      }}
                                      className="btn btn-secondary w-100"
                                    >
                                      Reset Filter
                                    </button>
                                  </div>
                                </div>
                              </div>
                              <div className="col-12 mt-2 " data-label="me">
                                <button
                                  className="btn btn-primary"
                                  data-bs-toggle="modal"
                                  data-bs-target="#manual-payment"
                                >
                                  Manual Payment Entry
                                </button>
                              </div>
                              <hr className="m-0 p-0 mt-3 text-dark" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-9 col-sm-12">
                    <div className="col-lg-12 col-sm-12">
                      <div className="card">
                        <div className="table-responsive">
                          <table className="table table-vcenter card-table">
                            <thead>
                              <tr className="">
                                <th>Name</th>
                                <th>Email</th>
                                {/* <th>Payment Id</th> */}
                                <th>Amount</th>
                                <th>Payment Date</th>
                                <th>Payment Status</th>
                                <th>View</th>
                              </tr>
                            </thead>
                            <tbody>
                              {data &&
                                data?.map((el, index) => {
                                  return (
                                    <tr key={index}>
                                      <td data-label="Name">
                                        <div>{el?.name || "NA"}</div>
                                      </td>
                                      <td data-label="Email">
                                        <div className="text-secondary">
                                          {el?.email ? el.email : "NA"}
                                        </div>
                                      </td>
                                      <td data-label="Amount">
                                        <div>{el?.amount || "NA"}</div>
                                      </td>
                                      <td data-label="Payment Date">
                                        <div>
                                          {el?.paymentDate
                                            ? returnMonthDateYear(
                                                el?.paymentDate
                                              )
                                            : "NA"}
                                        </div>
                                      </td>
                                      <td data-label="Payment Status">
                                        {el?.paymentStatus === "Completed" ? (
                                          <span className="status status-green border rounded-2 p-2">
                                            {el?.paymentStatus || "NA"}
                                          </span>
                                        ) : el?.paymentStatus === "Pending" ? (
                                          <span className="status status-red border rounded-2 p-2">
                                            {el?.paymentStatus || "NA"}
                                          </span>
                                        ) : el?.paymentStatus === "Sent" ? (
                                          <span className="status status-lime border rounded-2 p-2">
                                            {" "}
                                            {el?.paymentStatus || "NA"}
                                          </span>
                                        ) : (
                                          <span className="p-2">"NA"</span>
                                        )}
                                      </td>

                                      <td data-label="Job Id">
                                        <button
                                          data-bs-toggle="modal"
                                          onClick={() =>
                                            handleWebinarDetails(el)
                                          }
                                          className="btn btn-sm px-3 btn-primary"
                                          data-bs-target="#creditNote"
                                        >
                                          <BsArrowRightShort className="me-1" />
                                          view
                                        </button>
                                      </td>
                                    </tr>
                                  );
                                })}
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <div className="card">
                        <Pagination
                          page={page}
                          setPage={setPage}
                          totalPages={totalPages}
                          pageDatalength={data?.length}
                          showPage={showPage}
                          setShowPage={setShowPage}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>

        {/* Modal */}
        {/* Webinar  Details */}
        <div
          className="modal fade "
          id="creditNote"
          tabIndex="-1"
          role="dialog"
          aria-hidden="true"
        >
          <div
            className="modal-dialog modal-dialog-centered modal-dialog-scrollable "
            style={{ maxWidth: "800px" }}
          >
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Webinar Boooking Details</h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  id="btn-close"
                ></button>
              </div>
              <div className="modal-body">
                {webinarDetails && webinarPaymentDetails ? (
                  <div className="card-body">
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">Name</label>
                      <div className="col w-100">
                        {webinarPaymentDetails?.name}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">Email</label>
                      <div className="w-100 col">
                        {webinarPaymentDetails?.email}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label  col-3">
                        Phone number
                      </label>
                      <div className="w-100 col">
                        {webinarPaymentDetails?.mobile || "NA"}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Payment Id
                      </label>
                      <div className="w-100 col">
                        {webinarPaymentDetails?.paymentId}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">Amount</label>
                      <div className="w-100 col">
                        {webinarPaymentDetails?.amount || "N/A"}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label  col-3">
                        Payment Date
                      </label>
                      <div className="w-100 col">
                        {webinarPaymentDetails?.paymentDate
                          ? extractDate(webinarPaymentDetails?.paymentDate)
                          : "NA"}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label  col-3">
                        Payment Status
                      </label>
                      <div className="w-100 col">
                        {webinarPaymentDetails?.paymentStatus || "NA"}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label  col-3">
                        Webinar Name
                      </label>
                      <div className="w-100 col">
                        {webinarDetails?.webinarName}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Webinar Date
                      </label>
                      <div className="w-100 col">
                        {webinarDetails?.webinarDate}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Webinar Start Time
                      </label>
                      <div className="w-100 col">
                        {webinarDetails?.webinarStartTime}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Webinar End Time
                      </label>
                      <div className="w-100 col">
                        {webinarDetails?.webinarEndTime}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Webinar Access Url
                      </label>
                      <div
                        className="w-100 col"
                        style={{
                          wordBreak: "break-all",
                        }}
                      >
                        {webinarPaymentDetails?.sessionUrl ? (
                          <a
                            href={webinarPaymentDetails?.sessionUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {webinarPaymentDetails?.sessionUrl}
                          </a>
                        ) : (
                          "N/A"
                        )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Webinar Discounted Url
                      </label>
                      <div
                        className="w-100 col"
                        style={{
                          wordBreak: "break-all",
                        }}
                      >
                        {webinarPaymentDetails?.discountedUrl ? (
                          <a
                            href={webinarPaymentDetails?.discountedUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {webinarPaymentDetails?.discountedUrl}
                          </a>
                        ) : (
                          "N/A"
                        )}
                      </div>
                    </div>
                  </div>
                ) : (
                  "Data Not Available"
                )}
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Mannual Payment */}
        <div
          className="modal fade"
          id="manual-payment"
          tabIndex="-1"
          role="dialog"
          aria-hidden="true"
        >
          <div
            className="modal-dialog modal-dialog-centered modal-dialog-scrollable"
            style={{ maxWidth: "800px" }}
          >
            <div className="modal-content">
              <Formik
                initialValues={manualPaymentInitialValues}
                validationSchema={manualPaymentSchema}
                onSubmit={handleManualPaymentSubmit}
                enableReinitialize
              >
                {(props) => (
                  <Form>
                    <div className="modal-header">
                      <h5 className="modal-title">Manual Payment Entry</h5>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                        id="btn-close"
                      ></button>
                    </div>

                    <div className="modal-body">
                      <div className="card-body">
                        {/* Name */}
                        <div className="mb-3 row">
                          <label className="w-25 form-label col-3">Name</label>
                          <div className="col w-100">
                            <CustomInput name="name" type="text" />
                            {props.touched.name && props.errors.name && (
                              <p className="text-danger">{props.errors.name}</p>
                            )}
                          </div>
                        </div>

                        {/* Email */}
                        <div className="mb-3 row">
                          <label className="w-25 form-label col-3">Email</label>
                          <div className="col w-100">
                            <CustomInput name="email" type="email" />
                            {props.touched.email && props.errors.email && (
                              <p className="text-danger">
                                {props.errors.email}
                              </p>
                            )}
                          </div>
                        </div>

                        {/* Mobile */}
                        <div className="mb-3 row">
                          <label className="w-25 form-label col-3">
                            Mobile
                          </label>
                          <div className="col w-100">
                            <CustomInput name="mobile" type="text" />
                            {props.touched.mobile && props.errors.mobile && (
                              <p className="text-danger">
                                {props.errors.mobile}
                              </p>
                            )}
                          </div>
                        </div>

                        {/* Payment ID */}
                        <div className="mb-3 row">
                          <label className="w-25 form-label col-3">
                            Payment ID
                          </label>
                          <div className="col w-100">
                            <CustomInput name="paymentId" type="text" />
                            {props.touched.paymentId &&
                              props.errors.paymentId && (
                                <p className="text-danger">
                                  {props.errors.paymentId}
                                </p>
                              )}
                          </div>
                        </div>

                        {/* Payment Status (disabled) */}
                        <div className="mb-3 row">
                          <label className="w-25 form-label col-3">
                            Payment Status
                          </label>
                          <div className="col w-100">
                            <CustomInput
                              name="paymentStatus"
                              type="text"
                              disabled
                            />
                            {props.touched.paymentStatus &&
                              props.errors.paymentStatus && (
                                <p className="text-danger">
                                  {props.errors.paymentStatus}
                                </p>
                              )}
                          </div>
                        </div>

                        {/* Webinar Name */}
                        <div className="mb-3 row">
                          <label className="w-25 form-label col-3">
                            Webinar Name
                          </label>
                          <div className="col w-100">
                            <CustomInput name="webinarName" type="text" />
                            {props.touched.webinarName &&
                              props.errors.webinarName && (
                                <p className="text-danger">
                                  {props.errors.webinarName}
                                </p>
                              )}
                          </div>
                        </div>

                        <div className="mb-3 row">
                          <label className="w-25 form-label col-3">
                            Dummy Payment
                          </label>
                          <div className="col w-100">
                            <CustomSelect
                              name="dummyPayment"
                              className="form-select"
                            >
                              <option value="">select</option>
                              <option value="yes">Yes</option>
                              <option value="no">No</option>
                            </CustomSelect>
                            {props.touched.dummyPayment &&
                              props.errors.dummyPayment && (
                                <p className="text-danger">
                                  {props.errors.dummyPayment}
                                </p>
                              )}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="modal-footer">
                      <button
                        type="button"
                        className="btn btn-secondary"
                        data-bs-dismiss="modal"
                      >
                        Close
                      </button>
                      <button type="submit" className="btn btn-primary">
                        Save Entry
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AllWebinarPayments;
